// Web Push helpers for the Pocket PWA (weekly summary even when the app is closed)
import { financeApi } from './api';

const toKey = (b64) => {
  const pad = '='.repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + pad).replace(/-/g, '+').replace(/_/g, '/'));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const pushSupported = () =>
  'serviceWorker' in navigator && 'PushManager' in window && typeof Notification !== 'undefined';

export async function getPushSubscription() {
  if (!pushSupported()) return null;
  try {
    const reg = await navigator.serviceWorker.getRegistration('/pocket');
    return reg ? await reg.pushManager.getSubscription() : null;
  } catch { return null; }
}

export async function enablePush() {
  const perm = await Notification.requestPermission();
  if (perm !== 'granted') throw new Error('permission-denied');
  const reg = (await navigator.serviceWorker.getRegistration('/pocket'))
    || (await navigator.serviceWorker.register('/pocket-sw.js', { scope: '/pocket' }));
  await navigator.serviceWorker.ready;
  const { data } = await financeApi.pushPublicKey();
  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: toKey(data.key),
  });
  await financeApi.pushSubscribe({ subscription: sub.toJSON() });
  return sub;
}

export async function disablePush() {
  const sub = await getPushSubscription();
  if (sub) {
    try { await financeApi.pushUnsubscribe({ endpoint: sub.endpoint }); } catch { /* noop */ }
    await sub.unsubscribe();
  }
}
